'use client';

import type { FC, ReactNode } from 'react';

import Button from '../../../Button/Button';

export interface SimpleAlertModalProps {
  modalIcon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  confirmText?: string;
  closeText?: string;
  confirmAction: () => void;
  closeAction?: () => void;
  isLoadingConfirmButton?: boolean;
  isDisabledConfirmButton?: boolean;
}

/*
  모달이 열리면 headlessui 가 첫 버튼에 포커스를 준다. `focus:` 로 두면
  마우스로 연 사람에게도 테두리가 남아 눌러야 할 버튼처럼 보인다.
  키보드로 옮겨 다닐 때만 보이도록 `focus-visible:` 을 쓴다.
*/
const commonButtonStyle =
  'min-w-[120px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-CoolGray-700 text-nowrap';

const SimpleAlertModal: FC<SimpleAlertModalProps> = ({
  confirmAction,
  closeAction,
  title = '알림',
  description = '',
  confirmText = '확인',
  closeText,
  modalIcon,
  isLoadingConfirmButton = false,
  isDisabledConfirmButton = false,
}) => {
  return (
    <div className="w-[512px] mobile:w-[290px] p-[24px] flex flex-row items-start">
      {modalIcon && (
        <div className="w-10 h-10 mr-4 mobile:hidden">{modalIcon}</div>
      )}
      <div className="w-full">
        <header className="flex flex-col gap-y-2">
          <b className="text-lg/[22px] text-CoolGray-900 whitespace-break-spaces">
            {title}
          </b>
          <div className="text-sm/[18px] text-CoolGray-400 whitespace-break-spaces">
            {description}
          </div>
        </header>
        <div className="flex flex-row items-center justify-end mt-6">
          {closeText && (
            <Button
              className={`close ${commonButtonStyle}`}
              label={closeText}
              size="base"
              type={'button'}
              onClick={closeAction}
            />
          )}
          <Button
            className={`confirm ml-3 ${commonButtonStyle}`}
            label={confirmText}
            size="base"
            type={'button'}
            colorType="secondary"
            onClick={confirmAction}
            loading={isLoadingConfirmButton}
            disabled={isDisabledConfirmButton}
          />
        </div>
      </div>
    </div>
  );
};

export default SimpleAlertModal;
